export type EmailDebugDetails = {
  edgeStatusCode?: number;
  resendStatusCode?: number;
  resendStatusText?: string;
  resendResponseBody?: string;
  requestPayload?: unknown;
};

export type EmailDebugError = {
  title: string;
  details: string[];
  debug?: EmailDebugDetails;
};

export async function parseFunctionError(
  err: unknown,
  fallbackTitle: string,
  fallbackDetail: string,
): Promise<EmailDebugError> {
  const error = err as any;
  const details: string[] = [];
  let body: any = error?.context?.body ?? error?.context?.responseJson ?? null;
  let edgeStatusCode: number | undefined = error?.context?.status ?? error?.status;

  if (error?.context instanceof Response) {
    edgeStatusCode = error.context.status;
    try {
      const text = await error.context.clone().text();
      body = text ? JSON.parse(text) : null;
    } catch {
      try {
        body = await error.context.clone().text();
      } catch {
        body = null;
      }
    }
  }

  if (typeof body === "string") {
    try {
      body = JSON.parse(body);
    } catch {
      details.push(body);
    }
  }

  if (body?.error) details.push(String(body.error));
  if (error?.message && details.length === 0) details.push(String(error.message));
  if (details.length === 0) details.push(fallbackDetail);

  return {
    title: fallbackTitle,
    details,
    debug: body?.debug
      ? { edgeStatusCode, ...body.debug }
      : edgeStatusCode
        ? { edgeStatusCode }
        : undefined,
  };
}